import { Box, Paper, Table, TableContainer, TableBody } from "@mui/material";
import React from "react";
import TableList from "./TableList";
import EnhancedTableHead from "./TableHead";

export interface Data {
  id: number;
  complaintName: string;
  activeStatus: any;
  complaintsDescription: string;
  createdAt: string;
  updatedAt: string;
}

type Order = "asc" | "desc";

const DashTable = (props) => {
  const {
    activeIndex,
    HandEData,
    setShow,
    complaintsData,
    adviceData,
    diagnosisData,
    setUpdateData,
    refetch,
    refetchHandE,
    refetchAdvice,
    refetchDiagnosis
  } = props;
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("createdAt");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  return (
    <div className="Enhance-table">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer className="custom-tablebody">
            <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                activeIndex={activeIndex}
              />

              <TableBody>
                <TableList
                  setShow={setShow}
                  complaintsData={complaintsData}
                  HandEData={HandEData}
                  adviceData={adviceData}
                  diagnosisData={diagnosisData}
                  setUpdateData={setUpdateData}
                  refetch={refetch}
                  refetchHandE={refetchHandE}
                  refetchAdvice={refetchAdvice}
                  refetchDiagnosis={refetchDiagnosis}
                  activeIndex={activeIndex}
                />
              </TableBody>
            </Table>
            {/* {isLoading && (
              <div className="d-flex justify-content-center">
                <TableLoad />
              </div>
            )}
            {customer?.data?.length === 0 && (
              <div className="d-flex justify-content-center">
                <small className="m-3">No results found!</small>
              </div>
            )} */}
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
};

export default DashTable;
